/* eslint-disable import/no-anonymous-default-export */
import Auth from './Auth';

export default [
    Auth
];

